import { Alert, Col, Row, Table, Tabs } from "antd"
import {useContext, useState} from "react";
import { TabPane } from "semantic-ui-react"
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import {TemplateContext} from "../../../../utils/template_context";

export const RecoPubli = ({ jurado } : any) => {
    const context = useContext(TemplateContext);
    const columnsReconocimientos: any = [
        {
            title: "No.",
            width: 40,
            render: (datos: any, datos2: any, index: number) => {
                return (
                        <span>{index + 1}</span>
                );
            },
            fixed: context.device === "md"? "left": false,
        },
        {
            title: "Nombre reconocimiento",
            width: 200,
            dataIndex: "nombre_reconocimiento",
            key: "nombre_reconocimiento",
        },
        {
            title: "Institución que la otorga",
            width: 140,
            dataIndex: "institucion_otorga",
            key: "institucion_otorga",
        },
        {
            title: "Año",
            width: 140,
            dataIndex: "año",
            key: "año",
        },
        {
            title: "Ciudad",
            width: 140,
            dataIndex: "ciudad",
            key: "ciudad",
        },
        // {
        //     title: "Anexo",
        //     width: 140,
        //     render: (datos: any) => (
        //         <a role="button" tabIndex={0} className="button-azul-ghost" onClick={() => modalAnexo(datos)}>Anexo</a>
        //     )
        // },
    ];
    const columnsPublicaciones: any = [
        {
            title: "No.",
            width: 40,
            render: (datos: any, datos2: any, index: number) => {
                return (
                        <span>{index + 1}</span>
                );
            },
            fixed: context.device === "md"? "left": false,
        },
        {
            title: "Nombre publicaciones",
            width: 200,
            dataIndex: "titulo_publicacion",
            key: "titulo_publicacion",
        },
        {
            title: "Tema",
            width: 140,
            dataIndex: "tema",
            key: "tema",
        },
        {
            title: "Ciudad",
            width: 140,
            dataIndex: "ciudad",
            key: "ciudad",
        },
        {
            title: "Año",
            width: 140,
            dataIndex: "año",
            key: "año",
        },
        // {
        //     title: "Anexo",
        //     width: 140,
        //     render: (datos: any) => (
        //         <a role="button" tabIndex={0} className="button-azul-ghost" onClick={() => modalAnexo(datos)}>Anexo</a>
        //     )
        // },
    ];

    const [openModal, setOpenModal] = useState(false);
    const [documento] = useState('')

    return (
        <>
            <Tabs defaultActiveKey="1" >
                <TabPane tab="Reconocimientos" key="1">
                    {jurado.reconocimientos !== null &&jurado.reconocimientos.length !== 0 ?
                        (
                            <Row>
                                <Col>
                                    <Table
                                        dataSource={jurado.reconocimientos}
                                        columns={columnsReconocimientos}
                                        pagination={false}
                                        scroll={{ x: 1500, y: 300 }}
                                    />
                                </Col>
                            </Row>
                        )
                        :
                        (
                            <Alert
                                message="No se han diligenciados datos para está sección"
                                type="warning"

                            />
                        )
                    }

                </TabPane>
                <TabPane tab="Publicaciones" key="2">
                    {jurado.publicaciones !== null && jurado.publicaciones.length !== 0 ?
                        (
                            <Row>
                                <Col>
                                    <Table
                                        dataSource={jurado.publicaciones}
                                        columns={columnsPublicaciones}
                                        pagination={false}
                                        scroll={{ x: 1500, y: 300 }}
                                    />
                                </Col>
                            </Row>
                        )
                        :
                        (
                            <Alert
                                message="No se han diligenciados datos para está sección"
                                type="warning"

                            />
                        )
                    }
                </TabPane>
            </Tabs>
            {openModal &&
                <ModalVisualizarDocumentos
                    visualizar={openModal}
                    setVisualizar={setOpenModal}
                    state={{ documento }}
                />
            }
        </>
    )
}
